import Button from './Button.js'

export default function FilterA() {
    return (
        <>
        <div class="TL-SideBar-Container">
            <h1>Filter</h1>
            <h2>Subjects:</h2>
            <div>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
            </div>
            <h2>Locations:</h2>
            <div>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
            </div>
            <h2>Distance:</h2>
            <div>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
                <button class="Button-Extra-Small">Lorem</button>
            </div>
            <Button name="Apply" style="Button"/>
        </div>
        </>
    )
}